module.exports = __webpack_public_path__ + "static/media/shimakaze.91784182.png";